import axios from 'axios';
import moment from 'moment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import DatePicker from 'react-datepicker';
import Button from 'react-bootstrap/Button';
import Header from 'components/Header/header';
import React, { useState, useEffect } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { useHistory, useParams, Link } from 'react-router-dom';
import { LdsProgressIndicator } from '@elilillyco/ux-lds-react';

import '../../pages/NewData/index.css';
import '../../pages/AdminData/index.css';
import '../css/colors.css';
import 'react-datepicker/dist/react-datepicker.css';

import configData from '../../config.json';
import { msalInstance } from '../../authConfig';
import { prepareMetaDatabyIdRequestBody } from '../../utils/apiHelpers';

const EditUser = () => {
  document.title = 'プレスリリース | 管理画面';
  let history = useHistory();

  const API_SCOPES = ['api://39b64b04-e385-4232-a4e2-604367e2d849/.default'];

  const getApiToken = async () => {
    const authResult = await msalInstance.acquireTokenSilent({
      scopes: API_SCOPES,
      account: msalInstance.getAllAccounts()[0]
    });
    return authResult.accessToken;
  };
  const { id } = useParams();
  const [user, setUser] = useState({
    DocID: '',
    Release: '',
    Title: '',
    category: [],
    spt: '',
    status: '',
    modby: '',
    mod: '',
    FileName: '',
    Year: ''
  });
  const [errors, setError] = useState([]);
  const { DocID, Release, Title, category, spt, status } = user;
  const today = new Date();
  const time = moment(today).format('HH:mm');
  const [checkInDate, setCheckInDate] = useState(new Date());
  const [checkInTime, setCheckInTime] = useState(time);
  const [disabled, setDisabled] = useState(false);
  const [statuses, setStatus] = useState('');
  const [catchange, setCatchanged] = useState([]);
  const [uploadfilenew, setUploadfilenew] = useState({
    selectedFile: '',
    loaded: 0
  });
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState('');

  const onChangeHandler = (event) => {
    document.getElementById('form.browse').style.color = 'black';
    setUploadfilenew({
      selectedFile: event.target.files[0],
      loaded: 0
    });
  };

  const validate = async (Title, status, DocID, btnType) => {
    const errors = [];
    if (Title.length === 0 && status != 'Draft') {
      errors.push('タイトルを記入してください');
    }
    if (status.length === 0 && status != 'Draft') {
      errors.push('続行するにはスケジュールを選択してください');
    }
    var numberPattern = /^\d{4,5}/;
    if ((DocID && !DocID.toString().match(numberPattern)) || !DocID) {
      errors.push('4〜5桁の有効なDocIDを入力してください');
    }
    if (uploadfilenew.loaded === 0 && !user.FileName && status != 'Draft') {
      errors.push('ファイルを選択してUploadをクリックしてください。');
    }
    let currentDatetime = new Date();
    let currentTime = moment(currentDatetime).add(1, 'minutes').format('HH:mm');
    let ifScheduled = document.getElementById('Schedule').checked;
    let ifPublished = document.getElementById('Publish').checked;
    let currentDate = `${moment(currentDatetime).format('YYYY-MM-DD')}`;
    let checkInTime_new = moment(new Date(spt)).format('HH:mm');
    if (
      (!ifScheduled && !ifPublished && btnType == 'notDraft') ||
      (checkInTime_new <= currentTime && status == 'Scheduled' && checkInDate <= currentDatetime)
    ) {
      errors.push('現在以降の日時を選択してください。');
    }
    if (ifPublished && Release > currentDate) {
      errors.push('Publish nowの場合は、今日または今日より前の日時を選択してください');
    }
    return errors;
  };

  const handleCheckInDate = (e) => {
    setCheckInDate(e);
    var releaseYear = `${moment(e).format('YYYY-MM-DD')}`;
    releaseYear = releaseYear.split('-');
    setUser({
      ...user,
      Release: `${moment(e).format('YYYY-MM-DD')}`,
      spt: `${moment(e).format('YYYY-MM-DD')} ${checkInTime}`,
      Year: releaseYear[0],
      mod: new Date(),
      modby: `${msalInstance.getAllAccounts()[0]?.idTokenClaims?.name}`
    });
  };

  const handleCheckInTime = (e) => {
    setCheckInTime(e.target.value);
    setUser({
      ...user,
      Release: `${moment(checkInDate).format('YYYY-MM-DD')}`,
      spt: `${moment(checkInDate).format('YYYY-MM-DD')} ${e.target.value}`,
      mod: new Date(),
      modby: `${msalInstance.getAllAccounts()[0]?.idTokenClaims?.name}`
    });
  };

  const onInputChange = (e) => {
    var updatedCategory = category;
    var ifPublished = false;
    const { value, checked } = e.target;
    if (e.target.name == 'category') {
      setCatchanged((prevState) => {
        if (checked) {
          return [...prevState, value];
        } else {
          return prevState.filter((category) => category !== value);
        }
      });
    }
    if (e.target.value === 'Published') {
      setDisabled(true);
      document.getElementById('publishbtn').innerText = 'Publish';
      ifPublished = true;
    }
    if (e.target.value === 'Scheduled') {
      setDisabled(false);
      document.getElementById('publishbtn').innerText = 'Schedule';
    }
    var releaseYear = user.Release.split('-');
    if (!releaseYear.length > 0) {
      releaseYear = `${moment(checkInDate).format('YYYY-MM-DD')}`;
      releaseYear = releaseYear.split('-');
    }
    var scheduletime;
    if (!ifPublished) {
      scheduletime = moment(new Date(spt)).format('HH:mm');
      setCheckInTime(scheduletime);
    } else {
      scheduletime = checkInTime;
    }
    setUser({
      ...user,
      [e.target.name]: e.target.value,
      mod: new Date(),
      Year: releaseYear[0],
      category: `${catchange}`,
      modby: `${msalInstance.getAllAccounts()[0]?.idTokenClaims?.name}`,
      Release: `${moment(checkInDate).format('YYYY-MM-DD')}`,
      spt: `${moment(checkInDate).format('YYYY-MM-DD')} ${scheduletime}`
    });
  };

  const unSetLocal = async () => {
    // localStorage.clear();
    // sessionStorage.clear();
  };

  useEffect(() => {
    setUser((prevUser) => ({
      ...prevUser,
      category: catchange
    }));
  }, [catchange]);

  const isChecked = (value) => {
    return catchange.includes(value);
  };

  const publishData = async (e) => {
    console.log('[EditUser.publishData] === PUBLISH BUTTON CLICKED ===');
    const errors = await validate(Title, status, DocID, 'notDraft');
    if (errors.length > 0) {
      setError(errors);
      window.scrollTo(0, 0);
      return;
    } else {
      let newArray = { ...user, category: catchange.join(',') };

      let statusparam =
        document.getElementById('Publish').checked == true ? 'Published' : 'Scheduled';
      newArray = { ...newArray, status: statusparam };

      // Ensure Release date and metadata are always set before publishing
      newArray = {
        ...newArray,
        Release: `${moment(checkInDate).format('YYYY-MM-DD')}`,
        spt: `${moment(checkInDate).format('YYYY-MM-DD')} ${checkInTime}`,
        mod: new Date(),
        modby: `${msalInstance.getAllAccounts()[0]?.idTokenClaims?.name}`
      };

      console.log('[EditUser.publishData] Data prepared:', newArray);
      console.log('[EditUser.publishData] DocID:', newArray.DocID, 'Type:', typeof newArray.DocID);
      console.log('[EditUser.publishData] Release:', newArray.Release, 'Type:', typeof newArray.Release);
      console.log('[EditUser.publishData] Year:', newArray.Year, 'Type:', typeof newArray.Year);

      const accessToken = await getApiToken();
      var config = {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      setUser(newArray);
      
      const preparedBody = prepareMetaDatabyIdRequestBody(newArray, id);
      console.log('[EditUser.publishData] Final prepared request body:', JSON.stringify(preparedBody));
      console.log('[EditUser.publishData] API URL:', `${configData.MetaDatabyID}/${id}`);
      console.log('[EditUser.publishData] Sending PUT request...');
      
      try {
        const response = await axios.put(`${configData.MetaDatabyID}/${id}`, preparedBody, config);
        console.log('[EditUser.publishData] SUCCESS! Response:', response.data);
        history.push('/jp/admin');
      } catch (error) {
        console.error('[EditUser.publishData] === API ERROR ===');
        console.error('[EditUser.publishData] Status Code:', error.response?.status);
        console.error('[EditUser.publishData] Error Response:', error.response?.data);
        console.error('[EditUser.publishData] Error Message:', error.message);
        console.error('[EditUser.publishData] Full Error Object:', error);
        console.error('[EditUser.publishData] Request Body Sent:', preparedBody);
        throw error;
      }
    }
  };

  const backData = async (e) => {
    history.push('/jp/admin');
  };

  const updateDraft = async (e) => {
    const errors = await validate(Title, status, DocID, 'Draft');
    if (errors.length > 0) {
      setError(errors);
      window.scrollTo(0, 0);
      return;
    } else {
      let newArray = { ...user };
      newArray = { ...newArray, status: 'Draft' };

      const accessToken = await getApiToken();
      var config = {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      setUser(newArray);
      await axios.put(`${configData.MetaDatabyID}/${id}`, prepareMetaDatabyIdRequestBody(newArray, id), config);
      history.push('/jp/admin');
    }
  };

  const sendDataToNewTab = async (e) => {
    unSetLocal();
    localStorage.setItem('pageData', JSON.stringify(user));
    const errors = await validate(Title, status, DocID, 'notDraft');
    if (errors.length > 0) {
      setError(errors);
      window.scrollTo(0, 0);
      return;
    } else {
      // your axios call here
      sessionStorage.setItem('pageData', JSON.stringify(user));
      window.open('/jp/preview', 'preview', 'width=1200,height=500,top=50,left=50');
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const accessToken = await getApiToken();
    var config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    await axios.put(`${configData.MetaDatabyID}/${id}`, prepareMetaDatabyIdRequestBody(user, id), config);
    history.push('/jp/admin');
  };

  const previewPDF = async (e) => {
    e.preventDefault();
    const accessToken = await getApiToken();
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    try {
      const response = await axios.get(
        `${configData.previewPDF}?year=${user.Year}&filename=${user.FileName}`,
        config
      );
      const url = response?.data?.url;
      if (!url) {
        console.error('[previewPDF] No pre-signed URL returned');
        alert('プレビューの読み込みに失敗しました。');
        return;
      }
      window.open(
        url,
        'Popup',
        'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30'
      );
    } catch (err) {
      console.error('[previewPDF] Failed:', err);
      alert('プレビューの読み込みに失敗しました。');
    }
  };

  const onClickHandler = async (e) => {
    const selectedFile = uploadfilenew.selectedFile;
    var releaseYear = user.Release.split('-');
    if (!releaseYear.length > 0) {
      releaseYear = `${moment(checkInDate).format('YYYY-MM-DD')}`;
      releaseYear = releaseYear.split('-');
    }
    const accessToken = await getApiToken();
    setUploadfilenew({
      loaded: 1
    });
    setUploading(true);
    setUploadProgress(1);
    setUploadError('');

    var config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    const FILE_SIZE_LIMIT = 4 * 1024 * 1024; // 4 MB: hard limit — API Gateway base64-encodes the body before passing to Lambda (6 MB max), so ~4.5 MB is the effective ceiling; files above this go via S3 direct upload
    const MULTIPART_THRESHOLD = 20 * 1024 * 1024; // 20 MB: files above this use S3 multipart upload instead of a single presigned PUT
    console.log('[upload] Sending file:', selectedFile?.name, 'size:', selectedFile?.size, 'year:', releaseYear[0]);

    if (selectedFile.size <= FILE_SIZE_LIMIT) {
      // Small file (≤ 4 MB): send through the standard /upload endpoint (multer → API Gateway → Lambda)
      const data = new FormData();
      data.append('year', releaseYear[0]);
      data.append('docid', user.DocID);
      data.append('file', selectedFile);

      axios
        .post(configData.fileUploadapi, data, {
          ...config,
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              // Math.round can legitimately compute 0 for the first event
              // (loaded: 0); LdsProgressIndicator misreports a real 0 as
              // "not set", so floor at 1 while the upload is in progress.
              setUploadProgress(percent || 1);
            }
          }
        })
        .then((res) => {
          console.log('[upload] Success, response:', res.status, res.data);
          setUser({
            ...user,
            FileName: selectedFile.name,
            Year: releaseYear[0]
          });
        })
        .catch((err) => {
          console.error('[upload] Failed. Status:', err?.response?.status, 'Response:', JSON.stringify(err?.response?.data), 'Message:', err.message);
          setUploadError('アップロードに失敗しました。再試行してください。');
        })
        .finally(() => {
          setUploading(false);
          setUploadProgress(0);
        });
    } else if (selectedFile.size <= MULTIPART_THRESHOLD) {
      // Medium file (> 4 MB and ≤ 20 MB): get a presigned S3 URL and PUT the file directly to S3,
      // bypassing the API Gateway / Lambda payload limit.
      try {
        const s3Res = await axios.post(
          configData.fileUploadapi.replace('/upload', '/s3-upload'),
          {
            action: 'presigned-url',
            fileName: selectedFile.name,
            year: releaseYear[0],
            docId: user.DocID,
            fileType: selectedFile.type || 'application/pdf'
          },
          config
        );

        // Support both deployed Lambda format (uploadUrl/fileKey) and local format (url/key)
        const uploadUrl = s3Res.data.uploadUrl || s3Res.data.url;
        const fileKey = s3Res.data.fileKey || s3Res.data.key;
        const requiredHeaders = s3Res.data.requiredHeaders || {};
        if (!uploadUrl) throw new Error('[s3-upload] presigned-url response missing upload URL');
        console.log('[s3-upload] Uploading directly to S3, key:', fileKey);

        await axios.put(uploadUrl, selectedFile, {
          headers: {
            'Content-Type': selectedFile.type || 'application/pdf',
            ...requiredHeaders
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              // Math.round can legitimately compute 0 for the first event
              // (loaded: 0); LdsProgressIndicator misreports a real 0 as
              // "not set", so floor at 1 while the upload is in progress.
              setUploadProgress(percent || 1);
            }
          }
        });

        console.log('[s3-upload] Success');
        setUser({
          ...user,
          FileName: selectedFile.name,
          Year: releaseYear[0]
        });
      } catch (err) {
        console.error('[s3-upload] Failed:', err.message);
        setUploadError('アップロードに失敗しました。再試行してください。');
      } finally {
        setUploading(false);
        setUploadProgress(0);
      }
    } else {
      // Large file (> 20 MB): use S3 multipart upload to stay within S3 single-PUT limits
      const PART_SIZE = 5 * 1024 * 1024; // 5 MB per part (S3 minimum for all parts except the last)
      const s3UploadUrl = configData.fileUploadapi.replace('/upload', '/s3-upload');
      let uploadId = null;
      let fileKey = null;
      try {
        // 1. Initiate multipart upload
        const initiateRes = await axios.post(
          s3UploadUrl,
          {
            action: 'initiate-multipart',
            fileName: selectedFile.name,
            year: releaseYear[0],
            docId: user.DocID,
            fileType: selectedFile.type || 'application/pdf'
          },
          config
        );
        // The deployed Lambda may return the fields under different casing/names
        // (e.g. UploadId vs uploadId, fileKey vs key). Try all known variants so
        // the value is never silently undefined — undefined props are dropped by
        // JSON.stringify and cause a 400 "Missing required parameters" from the Lambda.
        uploadId = initiateRes.data.uploadId || initiateRes.data.UploadId;
        fileKey = initiateRes.data.key || initiateRes.data.fileKey || initiateRes.data.Key;
        if (!uploadId || !fileKey) {
          throw new Error(`[multipart] initiate-multipart returned unexpected response: ${JSON.stringify(initiateRes.data)}`);
        }
        console.log('[s3-upload multipart] Initiated, uploadId:', uploadId, 'key:', fileKey);

        // 2. Upload each part sequentially using upload-part-url (one call per part)
        const totalParts = Math.ceil(selectedFile.size / PART_SIZE);
        const parts = [];
        for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
          const start = (partNumber - 1) * PART_SIZE;
          const end = Math.min(start + PART_SIZE, selectedFile.size);
          const partBlob = selectedFile.slice(start, end);

          // Get presigned URL for this part
          const partUrlRes = await axios.post(
            s3UploadUrl,
            { action: 'upload-part-url', fileKey, uploadId, partNumber, fileName: selectedFile.name, year: releaseYear[0] },
            config
          );

          // PUT part directly to S3 and capture ETag
          const partUrl = partUrlRes.data.uploadUrl || partUrlRes.data.url;
          if (!partUrl) throw new Error(`[multipart] upload-part-url response missing URL: ${JSON.stringify(partUrlRes.data)}`);
          const putRes = await axios.put(partUrl, partBlob, {
            headers: { 'Content-Type': 'application/octet-stream' }
          });
          // ETag may be null if S3 CORS does not expose it; the deployed Lambda's
          // complete-multipart will use ListParts as fallback if parts are missing ETags.
          const etag = putRes.headers['etag'] || putRes.headers['ETag'];
          parts.push({ PartNumber: partNumber, ETag: etag });
          setUploadProgress(Math.round((partNumber / totalParts) * 100) || 1);
          console.log(`[s3-upload multipart] Part ${partNumber}/${totalParts} done, ETag:`, etag);
        }

        // 3. Complete multipart upload — send parts with ETags (deployed Lambda expects them)
        await axios.post(s3UploadUrl, { action: 'complete-multipart', fileKey, uploadId, parts }, config);
        console.log('[s3-upload multipart] Complete');

        setUser({
          ...user,
          FileName: selectedFile.name,
          Year: releaseYear[0]
        });
      } catch (err) {
        console.error('[s3-upload multipart] Failed:', err.message);
        if (uploadId && fileKey) {
          try {
            await axios.post(s3UploadUrl, { action: 'abort-multipart', fileKey, uploadId }, config);
          } catch (abortErr) {
            console.error('[s3-upload multipart] Abort failed:', abortErr.message);
          }
        }
        setUploadError('アップロードに失敗しました。再試行してください。');
      } finally {
        setUploading(false);
        setUploadProgress(0);
      }
    }
  };

  const loadUser = async () => {
    if (id == 'undefined') {
      history.push('/jp/error');
    }
    const accessToken = await getApiToken();
    var config = {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    const result = await axios.get(`${configData.MetaDatabyID}/${id}`, config);
    const alldata = result.data[0];

    let categoriesArray = Array.isArray(alldata.category)
      ? alldata.category
      : alldata.category.split(',');

    categoriesArray = categoriesArray.map((category) =>
      category === '業績発表' ? '企業情報' : category
    );

    if (categoriesArray.includes('一般')) {
      categoriesArray = [];
    } else {
      // Ensure "企業情報" is included if "業績発表" or "企業情報" is present
      if (categoriesArray.includes('業績発表') || categoriesArray.includes('企業情報')) {
        if (!categoriesArray.includes('企業情報')) {
          categoriesArray.push('企業情報');
        }
      }
    }
    setUser({ ...alldata });

    setCatchanged(categoriesArray);

    localStorage.setItem('statuss', JSON.stringify(alldata.status));
    sessionStorage.setItem('statuss', JSON.stringify(alldata.status));
    sessionStorage.setItem('Release', JSON.stringify(alldata.Release));
    setStatus(alldata.status);
    var Releasedate = JSON.stringify(alldata.Release);
    setCheckInDate(new Date(Releasedate));
  };

  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    // This useEffect runs after the component mounts and updates
    const statLabel = JSON.parse(window.sessionStorage.getItem('statuss'));
    const publishBtn = document.getElementById('publishbtn');
    
    if (publishBtn) { // Check if element exists before accessing properties
      const btnText = publishBtn.innerText;
      
      if (statLabel == 'Published') {
        const publishRadio = document.getElementById('Publish');
        const scheduleRadio = document.getElementById('Schedule');
        
        if (publishRadio) publishRadio.checked = true;
        if (scheduleRadio) scheduleRadio.disabled = true;
        publishBtn.innerText = 'Publish';
        setDisabled(true);
      } else if (statLabel == 'Scheduled' && btnText != 'Publish') {
        const publishRadio = document.getElementById('Publish');
        const scheduleRadio = document.getElementById('Schedule');
        
        if (scheduleRadio) scheduleRadio.checked = true;
        if (publishRadio) publishRadio.disabled = false;
        publishBtn.innerText = 'Schedule';
        setDisabled(false);
      }
    }
    
    // Handle file browse styling
    if (user.FileName != '' && uploadfilenew.selectedFile == '') {
      const browseElement = document.getElementById('form.browse');
      if (browseElement) {
        browseElement.style.color = 'white';
      }
    }
  }, [user, uploadfilenew]); // Dependencies to re-run when these change

  return (
    <>
      {uploading && (
        <>
          {/* Blurred full-page backdrop — blocks all user interaction */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backdropFilter: 'blur(4px)',
              backgroundColor: 'rgba(255,255,255,0.5)',
              zIndex: 9998
            }}
          />
          {/* LdsProgressIndicator centered on screen above the backdrop */}
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <LdsProgressIndicator
              ariaLabel="Processing"
              ariaValueMax={100}
              // 0 is a legitimate min, but the library's own falsy check
              // misreports it as "not set" and spams a console error;
              // a negligible non-zero value avoids that without any
              // visible or accessibility difference.
              ariaValueMin={0.0001}
              progress={uploadProgress}
              size={4}
            />
          </div>
        </>
      )}
      <div>
        <Header />
      </div>
      <div className=" w-100">
        <div className="col mb-3 col-12 text-center">
          <div className="row">
            {!(
              window.location.pathname.substring(
                6,
                window.location.pathname.lastIndexOf('/') + 0
              ) ==
              window.location.pathname.substring(
                window.location.pathname.lastIndexOf('/') + 1,
                window.location.pathname.length
              )
            ) ? (
              <div className="col-2 border-right">
                <Link to="/jp/admin">Home</Link>
              </div>
            ) : null}
            <div
              className={
                !(
                  window.location.pathname.substring(
                    6,
                    window.location.pathname.lastIndexOf('/') + 0
                  ) ==
                  window.location.pathname.substring(
                    window.location.pathname.lastIndexOf('/') + 1,
                    window.location.pathname.length
                  )
                )
                  ? 'col-10'
                  : 'col-12'
              }>
              <div className="d-flex justify-content-start mb-3 mt-4">
                <div className="container editUser">
                  {window.location.pathname.substring(
                    6,
                    window.location.pathname.lastIndexOf('/') + 0
                  ) ==
                  window.location.pathname.substring(
                    window.location.pathname.lastIndexOf('/') + 1,
                    window.location.pathname.length
                  ) ? (
                    <>
                      <div className="row mt48 text-left">
                        <div className="col-sm-9">
                          <h1>
                            プレスリリース
                            <br />
                            <sup>ニュース</sup>
                          </h1>
                        </div>
                      </div>
                      <div className="row text-left">
                        <div className="col-lg-9 col-md-8 col-sm-12">
                          <div className="p-2 col-lg-11 col-md-11 col-sm-12">
                            <h3>
                              {' '}
                              {moment(
                                JSON.parse(window.sessionStorage.getItem('pageDatas')).spt
                              ).format('MMMM Do, YYYY')}
                            </h3>
                            <p>
                              <a
                                className="pdf latest-story"
                                href="javascript:void(0)"
                                target="_blank">
                                {JSON.parse(window.sessionStorage.getItem('pageDatas')).Title}
                              </a>
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-4 d-none d-md-block">
                          <ul className="side-navigation p-2">
                            {' '}
                            <li>
                              <a
                                className="active"
                                href="/jp/news_list.html?page=1&amp;category=19">
                                {' '}
                                プレスリリース{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=18">
                                {' '}
                                バックナンバー2020年度{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=13">
                                {' '}
                                バックナンバー2019年度{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=12">
                                {' '}
                                バックナンバー2018年度{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=3">
                                {' '}
                                バックナンバー2017年度{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=4">
                                {' '}
                                バックナンバー2016年度{' '}
                              </a>
                            </li>{' '}
                            <li>
                              <a href="/jp/news_list.html?page=1&amp;category=5">
                                {' '}
                                バックナンバー2015年度{' '}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {}
                  <Form>
                    {uploadError && (
                      <div className="alert alert-danger alert-dismissible" role="alert">
                        {uploadError}
                        <button type="button" className="btn-close" onClick={() => setUploadError('')} aria-label="Close"></button>
                      </div>
                    )}
                    {errors.map((error) => (
                      <p className="mb-3" key={error}>
                        Error: {error}
                      </p>
                    ))}
                    {!(
                      window.location.pathname.substring(
                        6,
                        window.location.pathname.lastIndexOf('/') + 0
                      ) ==
                      window.location.pathname.substring(
                        window.location.pathname.lastIndexOf('/') + 1,
                        window.location.pathname.length
                      )
                    ) ? (
                      <>
                        <Form.Group as={Row} className="mb-3 fromSchedule">
                          <Form.Label as="legend" column sm={2}>
                            Schedule*
                          </Form.Label>
                          <Col sm={9}>
                          <div className="d-flex align-items-center flex-wrap">
                             <Form.Check
                              type="radio"
                              name="status"
                              id="Schedule"
                              value="Scheduled"
                              onChange={(e) => onInputChange(e)}
                              label="Set a schedule"
                              className="me-4 mb-2 d-flex align-items-center radio-label-nowrap"
                              required
                            />
                            <Form.Check
                              type="radio"
                              name="status"
                              id="Publish"
                              value="Published"
                              onChange={(e) => onInputChange(e)}
                              label="Publish now"
                              className="me-4 mb-2 d-flex align-items-center radio-label-nowrap"
                              required
                            />
                          </div>
                        </Col>
                        </Form.Group>
                        <InputGroup className="mb-3">
                          <Form.Label column sm="2">
                            Release Date & Time*
                          </Form.Label>
                          <Form.Group controlId="reldate">
                            <DatePicker
                              type="date"
                              selected={checkInDate}
                              minDate={disabled == true ? new Date('10/10/2014') : new Date()}
                              maxDate={disabled == true ? new Date() : new Date('10/10/2100')}
                              onChange={(e) => handleCheckInDate(e)}
                              name="Release"
                              className="dtpicker"
                              closeOnScroll={(e) => e.target === document}
                              value={moment(checkInDate).format('YYYY-MM-DD')}
                              required
                            />
                          </Form.Group>
                          <Form.Control
                            type="time"
                            aria-label="time"
                            disabled={disabled}
                            onChange={(e) => handleCheckInTime(e)}
                            value={moment(spt).format('HH:mm')}
                            required
                          />
                        </InputGroup>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1">
                          <Form.Label sm="2" className="col-sm-2">
                            Title*
                          </Form.Label>
                          <Col sm="10">
                            <Form.Control
                              name="Title"
                              value={Title}
                              onChange={(e) => onInputChange(e)}
                              required
                              as="textarea"
                              rows={2}
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="form.Category">
                          <Form.Label column sm="2">
                            Category*
                          </Form.Label>
                        <Col sm={10}>
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="checkBoxNew me-3 mb-2">
                              <Form.Check
                                type="checkbox"
                                id="category1"
                                name="category"
                                value="企業情報"
                                checked={isChecked('企業情報')}
                                onChange={(e) => onInputChange(e)}
                                label="企業情報"
                                className="d-flex align-items-center"
                              />
                            </div>
                            <div className="checkBoxNew me-3 mb-2">
                              <Form.Check
                                type="checkbox"
                                id="category2"
                                name="category"
                                value="製品・疾患"
                                checked={isChecked('製品・疾患')}
                                onChange={(e) => onInputChange(e)}
                                label="製品・疾患"
                                className="d-flex align-items-center"
                              />
                            </div>
                            <div className="checkBoxNew me-3 mb-2">
                              <Form.Check
                                type="checkbox"
                                id="category3"
                                name="category"
                                value="ソーシャルインパクト"
                                checked={isChecked('ソーシャルインパクト')}
                                onChange={(e) => onInputChange(e)}
                                label="ソーシャルインパクト"
                                className="d-flex align-items-center"
                              />
                            </div>
                          </div>
                        </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="form.docid">
                          <Form.Label column sm="2">
                            DOC ID*
                          </Form.Label>
                          <Col sm="10">
                            <Form.Control type="text" value={DocID} readonly disabled required />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="form.browse">
                          <Form.Label column sm="2">
                            PDF File Upload*
                          </Form.Label>
                          <Col sm="10 d-flex justify-content-left" style={{ height: '30px' }}>
                            {/* <Form.Control
                              type="file"
                              accept="application/pdf"
                              name="file"
                              onChange={(e) => onChangeHandler(e)}
                            /> */}
                            <input accept="application/pdf" name="file" type="file" id="form.browse" onChange={(e) => onChangeHandler(e)}
                           class="form-control-file-edit"></input>
                          </Col>
                          <Col
                            sm="10 d-flex justify-content-left"
                            style={{ height: '30px', paddingLeft: '18%' }}>
                            <Button
                              onClick={(e) => onClickHandler(e)}
                              class="btn btn-success btn-block"
                              variant="primary"
                              type="button"
                              disabled={uploading}
                              style={{
                                lineHeight: '0',
                                height: '100%',
                                marginRight: '10%'
                              }}>
                              Upload
                            </Button>{' '}
                            Uploaded File :
                            <a href="javascript:void(0)" onClick={(e) => previewPDF(e)}>
                              {user.FileName}
                            </a>{' '}
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column sm="2">
                            Status
                          </Form.Label>
                          <Col sm="2">{JSON.parse(window.sessionStorage.getItem('statuss'))}</Col>
                        </Form.Group>
                        <div className="button">
                          <Link
                            className="btn btn-primary"
                            variant="primary"
                            type="cancel"
                            to="/jp/admin">
                            Cancel
                          </Link>{' '}
                          {statuses == 'Draft' || statuses == 'Scheduled' ? (
                            <Button onClick={() => updateDraft(id)} variant="primary" disabled={uploading}>
                              Save as Draft
                            </Button>
                          ) : null}
                          {'   '}
                          <Button variant="primary" onClick={() => sendDataToNewTab(id)} disabled={uploading}>
                            Preview
                          </Button>
                          {'   '}
                          <Button onClick={() => publishData(id)} variant="primary" id="publishbtn" disabled={uploading}>
                            Schedule
                          </Button>
                          {'   '}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="button mt-4 float-right">
                          <Button
                            onClick={() => backData(id)}
                            variant="primary"
                            type="button"
                            className=" mr-2">
                            Back
                          </Button>
                          <Button onClick={() => publishData(id)} variant="primary">
                            {JSON.parse(window.sessionStorage.getItem('pageDatas')).status ==
                            'Published'
                              ? 'Publish'
                              : 'Schedule'}
                          </Button>
                        </div>
                      </>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
